module.exports = __webpack_public_path__ + "static/media/pca_data.13a9013c.csv";